import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    padding: 200px 60px 60px 60px;
    background: url(${props => props.bgDesktop }) top center #10151b no-repeat;
    display: flex;
    justify-content: center;

    @media only screen and (max-width: 1400px) {
        background: url(${props => props.bgMobile }) bottom center #10151b no-repeat;
        background-size: 100% auto;
        padding: 100px 60px 300px 60px;
    }

    @media only screen and (max-width: 900px) {
        padding: 100px 60px 200px 60px;
    }

    @media only screen and (max-width: 700px) {
        padding: 50px 30px 200px 30px;
    }

    @media only screen and (max-width: 500px) {
        padding: 50px 10px 30px 10px;
    }
    
`

export const ContainerInterno = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    max-width: 1436px;
    width: 100%;

    @media only screen and (max-width: 1400px) {
        flex-direction: column;
        justify-content: space-between;
    }
`

export const BoxCol4 = styled.div`
    width: 33.3333%;
    padding: 0 15px;

    @media only screen and (max-width: 1400px) {
        width: 100%;
        margin-bottom: 1000px;
    }

    @media only screen and (max-width: 900px) {
        margin-bottom: 800px;
    }

    @media only screen and (max-width: 700px) {
        margin-bottom: 500px;
    }

    @media only screen and (max-width: 500px) {
        margin-bottom: 330px;
    }

    @media only screen and (max-width: 400px) {
        margin-bottom: 320px;
    }
`

export const BoxCol6 = styled.div`
    width: 66.6666%;
    padding: 0 15px;
    text-align: center;

    @media only screen and (max-width: 1400px) {
        width: 100%;
    }
`

export const TagContador = styled.div`
    float: left;
    width: 100%;
    padding: 10px 20px;
    background-color: #EDC748;
    border-radius: 10px 10px 0 0;

    span {
        text-align: center;
        float: left;
        width: 100%;
        color: #0C0C0F;
        font-weight: 900;
        font-size: 15px;
        line-height: 22px;

        @media only screen and (max-width: 500px) {
            font-size: 14px;
            line-height: 22px;

            br {
                display: none;
            }
        }
    }
    
`

export const TextoBanner = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 28px;
    line-height: 38px;
    font-weight: 600;
    text-align: left;
    margin-top: 30px;
    text-transform: uppercase;

    strong {
        color: #EDC748;
        font-weight: 900;
    }

    @media only screen and (max-width: 1400px) {
        text-align: center;
    }

    @media only screen and (max-width: 500px) {
        font-size: 22px;
        line-height: 32px;
    }
`

export const ImgNaoSejaDemitido = styled.img`
    display: inline-block;

    @media only screen and (max-width: 500px) {
        max-width: 70%;
    }
`

export const TituloNaoSejaDemitido = styled.span `
    float: left;
    width: 100%;
    color: #fff;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    margin: 20px 0 20px 0;

    strong {
        color: #DCB84C;
    }

    @media only screen and (max-width: 500px) {
        font-size: 16px;
        line-height: 24px;
        margin: 10px 0;

        br {
            display: none;
        }

    }
    
`

export const LegendaNaoSejaDemitido = styled.span `
    float: left;
    width: 100%;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
`